import { slice } from './slice';

const { reducer } = slice;
export * as loyaltyUserSelectors from './selectors';

export default reducer;
